var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "19px",
    viewBox: "0 0 33 19",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-(1)",
    transform: "matrix(1 0 0 -1 0 19)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.258208 8.74365C4.47729 3.33185 10.195 0 16.5 0C22.805 0 28.5227 3.33185 32.7418 8.75017C33.0861 9.19355 33.0861 9.81297 32.7418 10.2563C28.5227 15.6682 22.805 19 16.5 19C10.195 19 4.47729 15.6682 0.258208 10.2498C-0.0860694 9.80645 -0.0860694 9.18703 0.258208 8.74365ZM16.9523 16.1898C12.767 16.4441 9.31068 13.1122 9.57395 9.06314C9.78997 5.72478 12.5914 3.01887 16.0477 2.81023C20.233 2.55594 23.6893 5.88778 23.4261 9.93686C23.2033 13.2687 20.4018 15.9746 16.9523 16.1898ZM12.7737 9.26527C12.6252 11.443 14.4883 13.2361 16.743 13.0992C18.5994 12.9883 20.1115 11.5343 20.233 9.72821C20.3816 7.55045 18.5184 5.75738 16.2637 5.8943C14.4006 6.01167 12.8885 7.46568 12.7737 9.26527Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.8874ff27b3ebc3dc0210bdc7b77f1e18.svg";
export { ForwardRef as ReactComponent };